import React from 'react';

const CustomDialogContent = ({ children }) => (
  <div className="custom-dialog-content">
    {children}
  </div>
);

export default CustomDialogContent;
